import { FieldLabel, type FieldLabelProps } from "@design-system/shadcn";
import React from "react";

import { useFieldContext } from "../core/form-contexts";

type FormFieldLabelProps = FieldLabelProps;

function FormFieldLabel({
  htmlFor,
  id,
  ...props
}: Readonly<FormFieldLabelProps>) {
  const field = useFieldContext<string>();

  if (!field) {
    throw new Error("FormFieldLabel must be used within form.AppField");
  }

  return (
    <FieldLabel
      htmlFor={htmlFor ?? field.name}
      id={id ?? `${field.name}-label`}
      {...props}
    />
  );
}

export { FormFieldLabel };
export type { FormFieldLabelProps };
